import { IUser } from '../models/user.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getProfile() {
  return request<IUser>({
    url: '/user/me',
    method: 'GET',
  });
}

function getList(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IUser>>({
    url: '/user',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IUser>({
    url: `/user/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IUser>) {
  return request<IUser>({
    url: `/user`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IUser>) {
  return request<IUser>({
    url: `/user/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IUser>({
    url: `/user/${id}`,
    method: 'DELETE',
  });
}

const userApi = Object.freeze({
  getProfile,
  getDetail,
  getList,
  create,
  update,
  remove,
});

export default userApi;
